import { EventEmitter } from "@angular/core";
import { ColumnModel } from "../../../shared/models/column.model";
import { PartCategoryModel } from "../../../shared/models/part-category.model";

export class PartCategoryBuildData{
    module = {
        name: "Category",
        new_name: "part/category",
        has_dot_menu: true,
        icon:'fa-ad',
        permission:'part_category'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:PartCategoryModel) => {//Generates Row for codeblack-table
        return PartCategoryModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}